import Script from 'next/script';

const OneLinkSmartScript = () => (
  <Script
    id="appsflyer-onelink"
    src={`${process.env.PUBLIC}/static/onelink-smart-script-V2.js`}
    type="text/javascript"
    strategy="beforeInteractive"
  />
);

export default OneLinkSmartScript;
